import { createSelector } from 'reselect/lib/index';
import { get } from 'lodash/fp';

export const themeSelector = (state) => state.theme;
export const getThemeSelector = createSelector(themeSelector, (theme) => get('theme', theme));
